import { ref } from 'vue';

export function useA11yLiveFeedback() {
  const liveRegionRef = ref<HTMLDivElement | null>(null);

  const giveA11yFeedback = (msg: string) => {
    if (!liveRegionRef.value) return;
    let message = msg;
    if (msg === liveRegionRef.value.textContent) {
      message += `\u200B`; // Add zero-width space to force re-read
    }
    liveRegionRef.value.textContent = message;
  };

  return {
    liveRegionRef,
    giveA11yFeedback,
  };
}

export default useA11yLiveFeedback;
